export enum AuthRoutePaths {
  LoginPage = '/login',
  SignupPage = '/cadastro',
  CallbackPage = '/callback',
  LogoutPage = '/logout',
  SsoLoginPage = '/sso',
  ResetPasswordPage = '/redefinir-senha'
}
